export default "__VITE_ASSET__U96NyV5R__"